import { Action } from '@ngrx/store';

export enum CategorieActionType {
  GET_CATEGORIES = '[Categorie] Get',
 
}
export class CrudCategorieAction implements Action {
  readonly type = CategorieActionType.GET_CATEGORIES;
  //add an optional payload
  constructor(public payload: any) {}
}


export type CategorieStateAction = CrudCategorieAction ;